import { createContext, useContext } from "react";
import type { LayoutData } from "@/types/domain";

type LayoutContextValue = {
  data: LayoutData;
  sideNavState: "mini" | "wide";
  toggleSideNav: () => void;
  mobileNavOpen: boolean;
  toggleMobileNav: () => void;
}

export const LayoutContext = createContext<LayoutContextValue | null>(null);

export const useLayout = (): LayoutContextValue => {
  const ctx = useContext(LayoutContext);
  if (!ctx) {
    throw new Error("useLayout must be used within an AppShell");
  }
  return ctx;
}
